import { useParams } from 'react-router-dom';

import { NavigateBack } from '../../../designComponents';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import AddDraftmanJob from './AddDraftmanJob';
// import AddPrinterJob from './AddPrinterJob';
import AddTechnicianJob from './AddTechnicianJob';

const CreateJobs = () => {
  const params = useParams();
  const { jobFor } = params;

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        {
          {
            technician: <AddTechnicianJob />,
            // printer: <AddPrinterJob />,
            draftman: <AddDraftmanJob />,
          }[jobFor || 'technician']
        }
      </div>
    </ViewJobContainerStyled>
  );
};

export default CreateJobs;
